//images
import CheckCircle from '../../../../images/check-circle.svg'
//styles
import '../../styles/tag/finalized.css'

const Finalized = () => {
  return (
    <div className='custom-tag__finalized'><img src={CheckCircle}/><span>finalized</span></div>
  )
}

export default Finalized